import axios from 'axios';

import { getApiEndPoint } from '../../../../helpers/apibase';
import { mapServerError } from '../../../../services/utils/serverErrorMapper';

export type WebOrderPageMode = 'Automatic' | 'Manual';

export type WebOrderPage = {
  OrderPagePath: string;
  Mode: WebOrderPageMode;
};

const api = axios.create({ baseURL: getApiEndPoint(), withCredentials: true });

const url = (appId: string) => `/api/v1.0/apps/${appId}/weborderpage`;

const getWebOrderPage = async (appId: string): Promise<WebOrderPage> => {
  try {
    const response = await api.get(url(appId));
    // Tolerate both a bare body and a RestApiResult-style `{ Data }` envelope.
    return response.data?.Data ?? response.data;
  } catch (e) {
    throw await mapServerError(e);
  }
};

const updateWebOrderPage = async (appId: string, update: WebOrderPage): Promise<void> => {
  try {
    await api.post(url(appId), update);
  } catch (e) {
    throw await mapServerError(e);
  }
};

export const webOrderPageService = { getWebOrderPage, updateWebOrderPage };
